(function($, queue) {
	queue.$new = createNew;
	
	queue.defaults = {
		/**
		 * Provjerava trenutne requestove u queue-u i dodaje samo ako je potrebno.
		 * Smisao false vrijednosti ovdje je prilikom punjenja forme (unos ili ispravak) kad 2 polja zovu istu funkciju.
		 * Da se ta funkcija ne bi pozivala 2 puta jedna za drugom (jer unos.popuniElemente poziva blur na svakom elementu) moguće je
		 * ovdje reći da ne želimo takvo ponašanje. 
		 */
		allowDuplicateReqs: true,
		/**
		 * Funkcija sa signatureom f(Request req1, Request req2) -> Boolean
		 * koja se može overrideati i određuje da li su requestovi jednaki.
		 * Koristi se kod dodavanja novog requesta u queue i ovisna je o opciji
		 * allowDuplicateReqs
		 */
		areReqsEqual: function(req1, req2) {
			if (typeof req1 !== typeof req2)
				return false;
			if (req1 === null || req2 === null)
				return false;
				
			if (typeof req1 === 'object')
				return req1.name === req2.name;
			
			return false;
		},
		/**
		 * @boolean
		 * 	   	true - automatski starta po dodavanju (add funkcija)
		 * 	   	false - starta pozivom start() funkcije 
		 * 
		 * Problem: 
		 * 		- queueDone event bi trebao dojaviti da je queue završio.
		 * 	   	- dva odmaknuta requesta će 2x izvršiti queueDone prema trenutnoj implementaciji da nakon svakog requesta
		 * 			provjeri da li je gotov
		 * Rješenja:
		 * 		- za _autoStart === true NE pozivati queueDone
		 * 		- uvesti end funkciju koja označava da se može pozvati queue done
		 */
		autoStart: false,
		/**
		 * Funkcija koja se izvrašava kad smo završili sa svih zahtjevima ili je došlo do stanja u kojem se nijedan zahtjev ne može više izvršiti
		 * jer dependencyji nisu izvršeni uspješno zbog greške ili nečega.
		 */
		queueDone: null
	};
	
	function createNew(opts) {
		return new KontoAjaxQueue(opts);
	}
	
	function KontoAjaxQueue(opts) {
		var aq = this;
		
		aq.options = $.extend({}, queue.defaults, opts);
		
		aq._addResolvedDependency = addResolvedDependency;
		aq._areDependenciesResolved = areDependenciesResolved;
		aq._checkIfDone = checkIfDone;
		aq._execute = execute;
		aq._executeResolved = executeResolved;
		aq._getResolved = getResolved;
		aq._hasRequestsInProgress = hasRequestsInProgress;
		aq._isDependencyResolved = isDependencyResolved;
		aq._inQueue = inQueue;
		aq._onBeforeExecute = onBeforeExecute;
		aq._onQueueDone = onQueueDone;
		aq._onRequestDone = onRequestDone;
		aq._onRequestError = onRequestError;
		aq._queue = [];
		aq._removeFromQueue = removeFromQueue;
		aq._resolvedDependencies = [];
		aq._started = aq.options.autoStart;
		
		aq.add = add;
		aq.done = false;
		aq.hasErrors = false;
		aq.isEmpty = isEmpty;
		aq.start = start;
		
		function add(req) {
			if (typeof req !== 'object' || req === null)
				req = {};
			
			if (typeof req.dependedOn === 'string') 
				req.dependedOn = [req.dependedOn];
			else if (!(typeof req.dependedOn === 'object' && req.dependedOn !== null && req.dependedOn.constructor === Array)) 
				req.dependedOn = [];
				
			if (!aq.options.allowDuplicateReqs && aq._inQueue(req)) {
				return;
			}
				
			aq._queue.push(req);
			
			req._inProgress = false;
			
			if (aq._started && aq._areDependenciesResolved(req.dependedOn)) {
				aq._execute(req);	
			}
		}
		
		function addResolvedDependency(name) {
			if (!aq._isDependencyResolved(name)) {
				aq._resolvedDependencies.push(name);
			}
		}
		
		function areDependenciesResolved(dependedOn) {
			var resolved = true;
			for (var i = 0; i < dependedOn.length; ++i) {
				if (!aq._isDependencyResolved(dependedOn[i])) {
					resolved = false;
					break;
				}
			}
			
			return resolved;
		}
		
		function checkIfDone() {
			var done = !aq._hasRequestsInProgress();
			if (done) {
				aq.done = true;
				aq._onQueueDone();
			} 
		}
		
		function execute(req) {
			aq._onBeforeExecute(req);
			
			req._inProgress = true;
			var jqxhr = $.dsDirectCall(req.params);
			jqxhr.done(function() {
				aq._onRequestDone(req);				
			});
			jqxhr.fail(function() {
				aq._onRequestError(req);
			});
			jqxhr.always(function() {
				req._inProgress = false;
				aq._checkIfDone();
			});
		}
		
		function executeResolved() {
			var resolved = aq._getResolved();
			resolved.map(execute.bind(aq));
		}
		
		function getResolved() {
			var resolved = $.grep(aq._queue, function(o) {
				return o._inProgress !== true && aq._areDependenciesResolved(o.dependedOn);
			});
			return resolved;
		}
		
		function hasRequestsInProgress() {
			var inprogress = $.grep(aq._queue, function(o) {
				return o._inProgress === true;
			});
			return inprogress.length > 0;
		}
		
		function inQueue(req) {
			for(var i = 0; i < aq._queue.length; ++i) {
				var r = aq._queue[i];
				if (aq.options.areReqsEqual(r, req))
					return true;
			}
			return false;
		}
		
		function isDependencyResolved(name) {
			return $.inArray(name, aq._resolvedDependencies) !== -1;	
		}
		
		function isEmpty() {
			return aq._queue.length === 0;
		}
		
		function onBeforeExecute(req) {
			if (typeof req.beforeExecute === 'function') {
				req.beforeExecute();
			}
		}
		
		function onQueueDone() {
			if (typeof aq.options.queueDone === 'function') {
				aq.options.queueDone.call(this);
			}
		}
		
		function onRequestDone(req) {
			aq._removeFromQueue(req);
			aq._addResolvedDependency(req.name);
			
			aq._executeResolved();
		}
		
		function onRequestError(req) {
			aq._removeFromQueue(req);
			
			aq.hasErrors = true;
		}
		
		function removeFromQueue(req) {
			aq._queue = $.grep(aq._queue, function(o) {
				return o !== req;
			});
		}
		
		function start() {
			aq._started = true;
			aq._executeResolved();
		}
	}
}(jQuery, konto.ajaxQueue = konto.ajaxQueue || {}));
